import React, { useState } from "react";
import { Box, Button, Modal, Backdrop, Typography } from "@mui/material";
import { FormCard } from "../../../components/ui/form";
import { Num } from "../../../components/ui";
import { tokens } from "../../../theme";

/** Dato del cliente: etiqueta chica arriba, valor abajo. Apila solo en teléfono. */
const ClientFact = ({ label, children, numeric }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
    <Typography sx={{ fontSize: "11.5px", fontWeight: 500, color: tokens.ink3 }}>
      {label}
    </Typography>
    {numeric ? (
      <Num sx={{ fontSize: "14px", fontWeight: 600 }}>{children || "—"}</Num>
    ) : (
      <Typography
        sx={{ fontSize: "14px", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis" }}
      >
        {children || "—"}
      </Typography>
    )}
  </Box>
);

const ClientInfo = ({ client }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <FormCard
        title={client?.company || "Cliente"}
        subtitle={`Cliente N° ${client?.clientId ?? "—"}`}
        action={
          <Button variant="outlined" onClick={() => setOpen(true)}>
            Ver ficha
          </Button>
        }
        sx={{ width: "100%", minWidth: 0 }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(190px, 1fr))" },
            gap: { xs: "12px", md: "16px" },
          }}
        >
          <ClientFact label="CUIT" numeric>{client?.cuit}</ClientFact>
          <ClientFact label="Email">{client?.email}</ClientFact>
          <ClientFact label="Teléfono" numeric>{client?.phone}</ClientFact>
        </Box>
      </FormCard>

      <ClientsModal open={open} setOpen={setOpen} client={client} />
    </>
  );
};

/** Fila etiqueta/valor de la ficha completa. */
const ModalRow = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "baseline",
      gap: "12px",
      flexWrap: "wrap",
      paddingY: "9px",
      borderTop: `1px solid ${tokens.borderSoft}`,
    }}
  >
    <Typography sx={{ fontSize: "12.5px", color: tokens.ink3, minWidth: 168 }}>{label}</Typography>
    <Typography sx={{ fontSize: "13px", fontWeight: 500, flexGrow: 1, minWidth: 0 }}>
      {value || "—"}
    </Typography>
  </Box>
);

const ClientsModal = ({ open, setOpen, client }) => {
  const handleClose = () => setOpen(false);

  return (
    <Modal
      aria-labelledby="ficha-cliente-titulo"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 32px)",
          maxWidth: 460,
          maxHeight: "82vh",
          overflowY: "auto",
          outline: "none",
          backgroundColor: tokens.surface,
          border: `1px solid ${tokens.border}`,
          borderRadius: `${tokens.radiusCard}px`,
          boxShadow: tokens.shadowMd,
          padding: { xs: "18px", md: "20px 22px" },
        }}
      >
        <Typography id="ficha-cliente-titulo" sx={{ fontSize: "14px", fontWeight: 600 }}>
          Ficha del cliente
        </Typography>
        <Typography sx={{ fontSize: "12px", color: tokens.ink3, marginTop: "2px", marginBottom: "8px" }}>
          {client?.company}
        </Typography>

        <ModalRow label="Nombre" value={[client?.name, client?.lastName].filter(Boolean).join(" ")} />
        <ModalRow label="CUIT" value={client?.cuit} />
        <ModalRow label="Email" value={client?.email} />
        <ModalRow label="Email de facturación" value={client?.emailBilling} />
        <ModalRow label="Teléfono" value={client?.phone} />
        <ModalRow label="Teléfono de facturación" value={client?.phoneBilling} />

        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
          <Button variant="outlined" onClick={handleClose}>
            Cerrar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ClientInfo;
